import { createSlice } from "@reduxjs/toolkit";

const initialSchoolProfile = {
  name: "",
  companyName: "",
  formationYear: "",
  mebsisNo: "",
  address: "",
  invoiceAddress: "",
  city: "",
  receiptOfPaymentOrderNo: "",
  accountingManager: "",
  isAccountingPersonnelAdded: true,
  preRegistrationFormSerialNumber: "",
  billNo: "",
  mailAddress: "",
  mailPassword: "",
  mailServerAddress: "",
  mailPortNumber: "",
  mailSSLUsage: true,
  smsUsername: "",
  smsPassword: "",
  smsOriginator: "",
  semesterCount: 0,
  dailyCourseHour: 0,
  courseHours: []
};

const initialSchoolProfileState = {
  actionsLoading: false,
  schoolProfile: initialSchoolProfile
};

// ...
const getCourseHours = (courseHours) => {
  for (let i = courseHours.length; i < 25; i++) {
    const courseHourInfo = {
      courseHour: i + 1,
      weekdayStartHour: "",
      weekdayEndHour: "",
      weekendStartHour: "",
      weekendEndHour: ""
    };
    courseHours = [...courseHours, courseHourInfo];
  }

  return courseHours;
};

export const schoolProfileSlice = createSlice({
  name: "schoolProfile",
  initialState: initialSchoolProfileState,
  reducers: {
    startCall: (state) => {
      state.actionsLoading = true;
    },
    //getSchoolProfile
    schoolProfileFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.schoolProfile = action.payload.entity;
      if (action.payload.isSuccess) state.schoolProfile.courseHours = getCourseHours(action.payload.entity.courseHours);
    },
    //saveSchoolProfile
    schoolProfileSaved: (state) => {
      state.actionsLoading = false;
    },
    //cleanSchoolProfileState
    schoolProfileStateCleaned: (state) => {
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.schoolProfile = initialSchoolProfile;
    }
  }
});